import { useState, useCallback, useEffect } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { mockPriorityAvatars } from '../../common/mocks';
import type { Priority, PriorityAvatar } from '../../common/types';
import { fetchAndMapPriorityAvatars } from '../../services/get-avatars';
import { messages } from './messages';

export const getSelectedAvatar = (priority: Priority) =>
	mockPriorityAvatars.find((avatar) => avatar.id === priority.avatarId);

type UseAvatarPickerReturn = {
	avatars: PriorityAvatar[];
	errorMessage: string | undefined;
	setErrorMessage: (errorMessage: string | undefined) => void;
};

export const useAvatarPicker = (): UseAvatarPickerReturn => {
	const { formatMessage } = useIntl();
	const [avatars, setAvatars] = useState<PriorityAvatar[]>([]);
	const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
	const accountId: string | null = useAccountId();

	const onFetch = useCallback(async () => {
		try {
			setAvatars(await fetchAndMapPriorityAvatars(accountId));
		} catch (error) {
			setErrorMessage(formatMessage(messages.avatarPickerGenericError));
		}
	}, [accountId, formatMessage]);

	useEffect(() => {
		(async () => {
			await onFetch();
		})();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		avatars,
		errorMessage,
		setErrorMessage,
	};
};
